import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useChatSocketStore from "@/stores/socket/chat.store";

import BottomBar from "@/components/dashboard/BottomBar";
import Footer from "@/components/dashboard/Footer";
import Navbar from "@/components/dashboard/Navbar";
import Sidebar from "@/components/dashboard/Sidebar";

import type { LayoutProps } from "@/types";
import { GamblingWarning } from "@/components/dialogs/gamblingWarning";
import useSelfExclusionStore from "@/stores/selfexclusion/store";
import useUserStore from "@/stores/authentication/store";
import ChatRoom from "@/components/dashboard/ChatRoom";
import { useMobileDetect } from "@/hooks";
import { ToastContainer } from "react-toastify";

const UserLayout = ({ children }: LayoutProps) => {
  const isMobile = useMobileDetect();
  const [isBottomBarVisible, setIsBottomBarVisible] = useState(true); // state liftednextuipro
  const [isChatOpened, setIsChatOpened] = useState(false);
  const isSelfExclusion = useSelfExclusionStore(
    (state) => state.isSelfExclusion,
  );
  const isOpenPopup = useSelfExclusionStore((state) => state.isOpenPopup);

  const skipPatterns = ["/games/iframe/", "live-chat"];

  const location = useLocation();
  const skipLayout = skipPatterns.some((pattern) =>
    location.pathname.includes(pattern),
  );

  const { isAuthenticated } = useUserStore();
  const { connectSocket, disconnectSocket } = useChatSocketStore();

  useEffect(() => {
    connectSocket(isAuthenticated);

    return () => {
      disconnectSocket();
    };
  }, [connectSocket, disconnectSocket, isAuthenticated]);

  return (
    <>
      {skipLayout ? (
        <>{children}</>
      ) : (
        <>
          <div className="ocean">
            <script
              id="ze-snippet"
              src="https://static.zdassets.com/ekr/snippet.js?key=38d7e7df-d930-4bed-8510-28a3b1040945"
              async={true}
            ></script>
            <script src="/scripts/gtag.ts" async={true}></script>
            <script src="/scripts/hotjar.ts" async={true}></script>
            <Navbar isBottomBarVisible={isBottomBarVisible} />{" "}
            {/* prop drilling */}
            <div className="flex ">
              <ToastContainer />
              <Sidebar handleCollapse={() => {}} />
              <div className="col-span-12 flex flex-col bg-dark-blue sm:col-span-10">
                <div
                  className={`w-fill-available m-auto w-[100vw] ${isMobile ? "max-w-[420px]" : "max-w-[1200px] "} ${location.pathname.includes("admin") && "w-full max-w-full"} p-3.5 lg:min-h-[72vh] lg:p-0`}
                >
                  {children}
                </div>
                <Footer />
              </div>
              <ChatRoom
                isOpen={isChatOpened}
                handleClose={() => setIsChatOpened(false)}
              />
            </div>
            {/* mobile */}
            <BottomBar
              isVisible={isBottomBarVisible}
              setIsVisible={setIsBottomBarVisible}
            />
          </div>
          {/* <LiveStatsModal */}
          {/*   isOpen={true} */}
          {/*   setIsOpen={setIsLiveStatsModelOpen} */}
          {/* /> */}
        </>
      )}
      {isSelfExclusion && isOpenPopup && <GamblingWarning />}
    </>
  );
};

export default UserLayout;
